import upload from '@/services/upload';
import createFileName from './createFileName';

type UploadResult = string | { url?: string; [key: string]: any } | null;



const blobToDataURL = (blob: Blob): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });

const uploadThumbnail = async (blob: File, product: any, index: number, folderName?: string): Promise<UploadResult> => {
    //const blob = await (await fetch(imageFile)).blob();
    const dataUrl = await blobToDataURL(blob);
    const fileName = createFileName(product, 'png', `section-${index}`);
    return upload({
        file: dataUrl,
        fileName,
        folderName: folderName || 'section_thumbnails'
    });
};

export default uploadThumbnail;